export const PHOTO_GALLERY_NAME = "hotel_photos_gallery";

export const PHOTO_INTERACTION_TYPE = {
	OPEN: "open",
	SWIPE: "swipe",
};

export const PHOTO_CLICKED_AREA = {
	MAIN_IMAGE: "main_image",
	GALLERY_MORE: "gallery_more",
};

export const PHOTO_SWIPE_DIRECTION = {
	LEFT: "left",
	RIGHT: "right",
};
